import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PairingChallengeContainerComponent } from '@era/devices';

@Component({
  selector: 'era-pair-confirm-page',
  templateUrl: './confirm.page.html',
  styleUrls: ['./confirm.page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [PairingChallengeContainerComponent],
})
export class PairConfirmPage {}
